import axios from 'axios';
import { OriginalDecisionQpcInSnippet } from '../decision/decision.types';
import { LegislationPopoverInfos } from './legislation.types';

export async function getLegislationFromArticleId(
  articleId: string,
): Promise<LegislationPopoverInfos> {
  return (
    await axios.get('/getLawFromArticleId', {
      params: {
        articleId,
      },
    })
  ).data;
}

export async function getLegislationCardQPCDecisions(
  articleId: string,
): Promise<Array<OriginalDecisionQpcInSnippet>> {
  return (
    await axios.get('/getLawCardQPCDecisions', {
      params: {
        articleId,
      },
    })
  ).data.qpcDecisions;
}
